

























import { Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';

@Component
export default class Uniqueness extends mixins(PlanLimitsMixin) {
  @Prop() 
  conditions: any;

  value: string = 'UNIQUE';
  predicate: string = 'EQUALS';

  mounted() {
    if (this.conditions.uniqueness) {
      this.value = this.conditions.uniqueness.values;
      this.predicate = this.conditions.uniqueness.predicate;
    }

  }

  @Watch('conditions', {
    immediate: true
  })
  onConditionsChanged(value: any, oldValue: any) {
    if(!value.uniqueness) {
      this.$set(this.conditions, 'uniqueness', {
        predicate:  'EQUALS',
        values: 'UNIQUE'
      });
    }
  }

  @Watch('value')
  onValueChanged(value: string, oldValue: string) {
    this.$set(this.conditions.uniqueness, 'values', value);
  }

  @Watch('predicate')
  onPredicateChanged(value: string, oldValue: string) {
    this.$set(this.conditions.uniqueness, 'predicate', value);
  }
}
